import httpService from "@src/utility/httpService";
const _httpService = new httpService();
import { config } from '@uhg-abyss/web/tools/config';
import { checkIsInternal } from "./createStorage";
import { commonText } from "@src/constants/common-constants";
    if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
    }
    else{
        _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
    }
export const getMetricsData = () => {

    const fetchData = async () => {
        try {
            const response: any = await _httpService.get(
                '/metric-definitions/',
            );
            return response.Data
            ;
        }
        catch(e) {
           return [];
        }
    };
    return fetchData();
};
export const getProviderMetrics = () => {
    const fetchData = async () => {
        try {
            const providerId = JSON.parse(sessionStorage.getItem('providerInfo') || '{}')?.ProviderSysKey;
            if(!providerId) return [];
            const response: any = await _httpService.get(
                '/provider-metrics-ids/'+providerId
            );
            return response;
            ;
        }
        catch(e) {
           return [];
        }
    };
    return fetchData();
};
export const getProviderMetricsIds = (): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const providerId = JSON.parse(sessionStorage.getItem('providerInfo') || '{}')?.ProviderSysKey;
      const response: any = await _httpService.get('/provider-metrics-ids/' + providerId);
      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
};
export const getCurrentUserInfoBykey = (key)  =>{
    const currentUser = getcurrentUser2();
    return currentUser && currentUser[0] ? currentUser[0][key] : '';
  }
export const getHealthCareOrgName = () => {
    return getCurrentUserInfoBykey('HealthCareOrganizationName') ?? "";
  }

  const getcurrentUser2 = () =>{
    try {
      if (sessionStorage.getItem('currentUser')) {
        return JSON.parse(sessionStorage.getItem('currentUser'));
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
  export const getcurrentUser = () => {
    if (sessionStorage.getItem('currentUser')) {
      return sessionStorage.getItem('currentUser');
    }
    return null;
  }

  export const isMultiTinVal =() =>{
    if (sessionStorage?.getItem('multiTinNavigation')) {
      return true;
    } else {
      return false;
    }
  }
  export const getMultiTins = ()=> {
    if (checkMultiTin()) {
      return sessionStorage.getItem('multiSelectedTins');
    } else {
      return '';
    }
  }
  export function checkMultiTin() {
    return sessionStorage.getItem('multiTinNavigation') &&
      sessionStorage.getItem('multiSelectedTins').split(',').length > 1;
  }
  export const updateGeoSegmentFilters = (state) => {
    if (state && ['REGION', 'STATES'].includes(state.key)) {
      const _value = !Array.isArray(state.value)
        ? { ...state.value, isChipDisable: !!state.value.isChipDisable }
        : state.value.map((value) => ({ ...value, isChipDisable: !!value.isChipDisable }));
      sessionStorage.setItem('GEO_SELECTED_' + state.key, JSON.stringify(_value));
    }
  }
  export function checkHCO() {
    return !sessionStorage.getItem('multiTinNavigation');
  }
  export function isNavigatedFromTinPage() {
    return sessionStorage.getItem('navigatedFromTinPage');
  }
  export function getLoggedUser() {
    if (sessionStorage.getItem('loggedUser')) {
      return sessionStorage.getItem('loggedUser');
    }
    return null;
  }

  export const providerKeyData = () => {
    return getCurrentUserInfoBykey('ProviderKey');
  }

  export function matchLobWithFilterLabel(lob) {
    return commonText[lob] || undefined;
  }
  export const checkTin = () => {
    const serializedState = JSON.parse(sessionStorage.getItem('state') || '{}');
    const extendedCorporateTinSelected = serializedState.extendedCorporateTinSelected;
    return extendedCorporateTinSelected && extendedCorporateTinSelected.Tinname !== 'All' && extendedCorporateTinSelected.Tinname !== 'All Selected TINs';
  }
  export const currentState = () => {
    return JSON.parse(sessionStorage.getItem('state') || '{}');
  }

  //KC data
  export const getMetricsDataKc= async (payload:any) =>{
 const url='/metric-definitions/';
    try {
           const responseData: any = await _httpService.get(url, payload);

                return responseData;
            } catch {
                return null;
            }
  }
  export const getTopMarketFilterData = async (payload: any) => {
    const url = '/claim-search/topfilter';
    const postData = async () => {
      try {
        const response: any = await _httpService.push(url, payload);
        return response;
      } catch (error) {
        console.error("Error in getTopMarketFilterData:", error);
        return null;
      }
    };
    return postData();
  };

export const geoFormatValues = (geoValues) => {
    if (!geoValues || typeof geoValues !== 'string') return geoValues;

    const isTitleCase = (str) => {
        const words = str.split(' ');
        return str === words
            .map((word, index) => {
                // Check if previous word contains a comma or forward slash
                const prevWordHasSeparator = index > 0 && (words[index - 1].includes(',') || words[index - 1].includes('/'));
                const cleanWord = word.replace(/[^A-Za-z]/g, '');

                // If word is 2 letters and comes after a separator, keep uppercase
                if (cleanWord.length === 2 && prevWordHasSeparator) {
                    return word.replace(cleanWord, cleanWord.toUpperCase());
                }

                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join(' ');
    };

    if (isTitleCase(geoValues)) {
        return geoValues;
    }

    return geoValues.split(' ')
        .map((word, index, words) => {
            // Check if the previous word contains a comma or forward slash
            const prevWordHasSeparator = index > 0 && (words[index - 1].includes(',') || words[index - 1].includes('/'));
            const cleanWord = word.replace(/[^A-Za-z]/g, '');

            // If the clean word is exactly 2 letters AND comes after a separator, keep it uppercase
            if (cleanWord.length === 2 && prevWordHasSeparator) {
                return word.replace(cleanWord, cleanWord.toUpperCase());
            }

            // Handle forward slash - capitalize first letter after /
            if (word.includes('/')) {
                return word.split('/').map(part =>
                    part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
                ).join('/');
            }

            // Otherwise, apply normal title case rules
            return word.length > 2 ?
                word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() :
                word.toLowerCase();
        })
        .join(' ');
};

export const postDataToAiGenie = async (payload: Record<string, any>) => {
  return new Promise((resolve, reject) => {
    if (!payload || typeof payload !== 'object') {
      reject({
        status: 400,
        message: 'Invalid payload. Expected an object.',
        data: null,
      });
      return;
    }

    setTimeout(() => {
      resolve({
        status: 200,
        message: 'Success',
        data: payload,
      });
    }, 300);
  });
};

// Fetch DOP or DOS from session storage. Stored in state object of Session Storage.

export const getViewByType = (): 'DOP' | 'DOS' => {
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
  if(sessionState?.viewClaimsByFilter === 'DOP' || sessionState?.viewClaimsByFilter === 'DOS') {
    return sessionState?.viewClaimsByFilter;
  }
  return 'DOS'; // Default to DOS if not set
};

// Fetch taxIds from session storage. Stored in state object of Session Storage with key 'taxId'.

export const getTaxIdsFromSession = (): string[] => {
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
  return sessionState?.taxId || [];
};

// Fetch geoRegion from session storage. Stored in state object of Session Storage with key 'Region'.

export const getGeoRegionFromSession = (): string => {
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
  return sessionState?.region || '';
};

// Fetch geoMarket from session storage. Stored in state object of Session Storage with key 'Market'.

export const getGeoMarketFromSession = (): string[] => {
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
  return sessionState?.market || [];
};

// Fetch geoState from session storage. Stored in state object of Session Storage with key 'States'.

export const getGeoStateFromSession = (): string[] => {
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
  return sessionState?.states || [];
};

// Fetch Total TIN Count from taxId stored in session storage to identify Bulk Flow.

export const getTotalTinCountFromSession = (): number => {
  const sessionState = JSON.parse(sessionStorage.getItem('state') || '{}');
  return sessionState?.taxId?.length || 0;
};